var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_2437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2687 0H2.73132C2.00693 0 1.31221 0.279986 0.799985 0.778364C0.287764 1.27674 0 1.95269 0 2.6575V33.3425C0 34.0473 0.287764 34.7233 0.799985 35.2216C1.31221 35.72 2.00693 36 2.73132 36H34.2687C34.9931 36 35.6878 35.72 36.2 35.2216C36.7122 34.7233 37 34.0473 37 33.3425V2.6575C37 1.95269 36.7122 1.27674 36.2 0.778364C35.6878 0.279986 34.9931 0 34.2687 0ZM11.0281 30.6675H5.46521V13.475H11.0281V30.6675ZM8.24278 11.0925C7.61177 11.089 6.99595 10.9038 6.47305 10.5601C5.95014 10.2165 5.54359 9.7298 5.30469 9.16153C5.06578 8.59327 5.00525 7.96889 5.13071 7.36718C5.25618 6.76548 5.56203 6.21341 6.00966 5.78067C6.45728 5.34793 7.02663 5.0539 7.64584 4.93569C8.26506 4.81748 8.90638 4.88039 9.48888 5.11648C10.0714 5.35257 10.569 5.75125 10.9188 6.26222C11.2686 6.77319 11.4551 7.37354 11.4546 7.9875C11.4605 8.39855 11.3814 8.80656 11.2218 9.18721C11.0622 9.56785 10.8256 9.91335 10.5258 10.2031C10.2261 10.4929 9.86952 10.7209 9.47728 10.8737C9.08504 11.0265 8.6652 11.1009 8.24278 11.0925ZM31.5322 30.6825H25.9719V21.29C25.9719 18.52 24.7617 17.665 23.1995 17.665C21.5499 17.665 19.9312 18.875 19.9312 21.36V30.6825H14.3683V13.4875H19.7179V15.87H19.7899C20.3269 14.8125 22.2077 13.005 25.0778 13.005C28.1817 13.005 31.5348 14.7975 31.5348 20.0475L31.5322 30.6825Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_2437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.33d75e3831e36a0d82b65fccace2e220.svg";
export { ForwardRef as ReactComponent };